import React from 'react';
import loading_gif from '../Images/loading.gif';
import './SitePreview.css';

class SitePreview extends React.Component {
	constructor(props) {
		super(props);
		// State management:
		if (this.props.location.state) { // Allow stateful linking
			this.state = this.props.location.state;
		}
		else {
			this.state = {
				error: null,
				isLoaded: false,
				selectedSite: null,
				sitesList: [],
				pubTypesList: [],
				tableData: [],
				tableCols: [],
				sortCol: 'publishedDate',
				sortDir: 'desc',
				page: 0,
				totalPages: 0,
				filterString: '',
				filterArr: {
					title: '',
					publishedDate: '',
					authorName: '',
					status: '',
					publicationEvent: '',
					publicationTypeId: '',
					attendees: ''
				}
			};
		}

		// Function bindings:
		this.fetchInitialData = this.fetchInitialData.bind(this);
		this.fetchTableData = this.fetchTableData.bind(this);
		this.filterChange = this.filterChange.bind(this);
		this.sortChange = this.sortChange.bind(this);
		this.prevPage = this.prevPage.bind(this);
		this.nextPage = this.nextPage.bind(this);
		this.handleSiteSwapChange = this.handleSiteSwapChange.bind(this);
	}

	// Populate site selector dropdown
	fetchInitialData() {
		const urls = [
			'/webpub-services/siteAPI/getSitesByOrganization/' + this.props.activeOrg,
			'/webpub-services/publicationTypesAPI/getAllPublicationTypes'
		];

		// Asynchronously retrieve all our stuff in one clump
		Promise.all(
			urls.map((url) => {
				return fetch(url).then(res => res.json());
			}
		))
		.then((data) => { // Everything is resolved at this point. Process it.
			this.setState({
				sitesList: data[0],
				pubTypesList: data[1],
				isLoaded: true,
				error: null
			});
		});
	}

	// Refresh table data, likely because the user swapped sites, sorts, or filters
	fetchTableData() {
		if (this.state.selectedSite && this.state.selectedSite > 0) {
			// Get site pubs
			this.setState({
				page: 0,
				totalPages: 0,
				tableData: []
			}, () => {
				fetch('/webpub-services/publicationAPI/getAllPublications?page=' + this.state.page
					+ '&sort=' + this.state.sortCol + ',' + this.state.sortDir
					+ '&size=10' + this.state.filterString + '&siteId=' + this.state.selectedSite
					+ '&approved=true')
				.then(res => res.json())
				.then(
					(result) => {
						if (result.content && result.content.length && result.content[0].title) { // Results look like we expect
							// If there's something we need to do to these, it could happen here.
							// It might be safer to do it in render(), though.
							let content = [];
								
							let foundIds = [];
							content = result.content.map((pub) => {
								if (!foundIds.includes(pub.id)) {
									foundIds.push(pub.id);
									return pub;
								}
								else return null;
							}).filter(res => res !== null);
							

							this.setState({
								tableData: content,
								totalPages: result.totalPages
							});
						}
						else if (result.numberOfElements === 0) { // Results empty, but real
							this.setState({
								tableData: [],
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else { // Something went wrong. Give up.
							this.setState({
								error: {message: 'Publication results malformed. (SP87)'},
								isLoaded: true
							});
						}
					},

					(error) => {
						this.setState({
							isLoaded: false,
							error: error,
							tableData: []
						});
					}
				)
			});

			// Get site columns
			fetch('/webpub-services/siteColumnAPI/getColumnsBySiteId/' + this.state.selectedSite)
			.then(res => res.json())
			.then(
				(result) => {
					if (result) {
						// Order results as expected: Author, Title, Status, Publication/Event, Type, Date
						let columnsList = [];
						if (result.filter(column => column.columnName === 'author').length) {
							columnsList.push({columnName: 'author'});
						}
						if (result.filter(column => column.columnName === 'title').length) {
							columnsList.push({columnName: 'title'});
						}
						if (result.filter(column => column.columnName === 'status').length) {
							columnsList.push({columnName: 'status'});
						}
						if (result.filter(column => column.columnName === 'publicationEvent').length) {
							columnsList.push({columnName: 'publicationEvent'});
						}
						if (result.filter(column => column.columnName === 'publicationTypeId').length) {
							columnsList.push({columnName: 'publicationTypeId'});
						}
						if (result.filter(column => column.columnName === 'publishedDate').length) {
							columnsList.push({columnName: 'publishedDate'});
						}
						if (result.filter(column => column.columnName === 'attendees').length) {
							columnsList.push({columnName: 'attendees'});
						}

						this.setState({
							tableCols: columnsList
						});
					}
				},

				(error) => {
					this.setState({
						isLoaded: false,
						error: error,
						tableCols: []
					});
				}
			);
		}
		else {
			this.setState({
				tableData: [],
				tableCols: []
			});
		}
	}

	// Get the previous page's results, preserving the current sort
	prevPage() {
		if (this.state.page >= 1) {
			this.setState((prevState, props) => ({
				page: prevState.page - 1
			}), () => {
				fetch(
					'/webpub-services/publicationAPI/getAllPublications?page=' + this.state.page
					+ '&sort=' + this.state.sortCol + ',' + this.state.sortDir
					+ '&size=10' + this.state.filterString + '&siteId=' + this.state.selectedSite
					+ '&approved=true'
				)
				.then(res => res.json())
				.then(
					(result) => {
						if (result.content && result.content.length && result.content[0].title) { // Results look like we expect
							// If there's something we need to do to these, it could happen here.
							// It might be safer to do it in render(), though.
							let content = [];
							if (this.state.sortCol === 'authors.authorName') {
								let foundIds = [];
								content = result.content.map((pub) => {
									if (!foundIds.includes(pub.id)) {
										foundIds.push(pub.id);
										return pub;
									}
									else return null;
								}).filter(res => res !== null);
							}
							else {
								content = result.content;
							}

							this.setState({
								tableData: content,
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else if (result.numberOfElements === 0) { // Results empty, but real
							this.setState({
								tableData: [],
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else { // Something went wrong. Give up.
							this.setState({
								error: {message: 'Publication results malformed. (MP107)'}
							});
						}
					},

					(error) => {
						this.setState({
							isLoaded: false,
							error: error
						});
					}
				);
			});
		}
	}

	// Get the next page's results, preserving the current sort
	nextPage() {
		if (this.state.page < (this.state.totalPages - 1)) {
			this.setState((prevState, props) => ({
				page: prevState.page + 1
			}), () => {
				fetch(
					'/webpub-services/publicationAPI/getAllPublications?page=' + this.state.page
					+ '&sort=' + this.state.sortCol + ',' + this.state.sortDir
					+ '&size=10' + this.state.filterString + '&siteId=' + this.state.selectedSite
					+ '&approved=true'
				)
				.then(res => res.json())
				.then(
					(result) => {
						if (result.content && result.content.length && result.content[0].title) { // Results look like we expect
							// If there's something we need to do to these, it could happen here.
							// It might be safer to do it in render(), though.
							let content = [];
							if (this.state.sortCol === 'authors.authorName') {
								let foundIds = [];
								content = result.content.map((pub) => {
									if (!foundIds.includes(pub.id)) {
										foundIds.push(pub.id);
										return pub;
									}
									else return null;
								}).filter(res => res !== null);
							}
							else {
								content = result.content;
							}

							this.setState({
								tableData: content,
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else if (result.numberOfElements === 0) { // Results empty, but real
							this.setState({
								tableData: [],
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else { // Something went wrong. Give up.
							this.setState({
								error: {message: 'Publication results malformed. (MP107)'}
							});
						}
					},

					(error) => {
						this.setState({
							isLoaded: false,
							error: error
						});
					}
				);
			});
		}
	}

	// Alters the filter string due to user input, then fetches data with the new string
	filterChange(event) {
		const target = event.target;
		var currentFilter = this.state.filterArr;
		var newString = '';

		// Do some sanitizing
		var filterVal = target.value.replace(/[^a-z0-9 .,_-]/gim,"");

		if (target.name === 'publishedDate' && filterVal !== '') {
			filterVal = parseInt(filterVal); // Strip out any non-integer characters
			if (!isNaN(filterVal) && filterVal > 0 && filterVal < 9999) {
				filterVal = '' + filterVal; // Get back to a string for the next step
				filterVal.padStart(4, '0');
			}
			else {
				filterVal = currentFilter['publishedDate'];
			}
		}

		currentFilter[target.name] = filterVal;

		// Build URL filter string
		Object.keys(currentFilter).map(function(objectKey, index) {
			if (currentFilter[objectKey] !== null && currentFilter[objectKey] !== '') {
				newString += '&' + objectKey + '=' + currentFilter[objectKey];
			}

			return true;
		});

		this.setState({
			filterArr: currentFilter,
			filterString: newString
		}, () => {
			this.fetchTableData();
		});
	}

	// Alters the sort variables due to user input, then fetches data with the new sorting parameters
	sortChange(event) {
		const target = event.currentTarget;
		const targetName = target.attributes.name.value;

		if (targetName === this.state.sortCol) {
			const newDir = this.state.sortDir === 'asc' ? 'desc' : 'asc';

			this.setState({ sortDir: newDir }, () => { this.fetchTableData(); });
		}
		else {
			this.setState({
				sortDir: 'asc',
				sortCol: targetName
			}, () => { this.fetchTableData(); });
		}
	}

	// User selected another site. Record that and send the siteId off for data fetch
	handleSiteSwapChange(changeEvent) {
		this.setState({
			selectedSite: parseInt(changeEvent.target.value),
			sortCol: 'createdDate',
			sortDir: 'asc',
			filterString: '',
			filterArr: {
				title: '',
				publishedDate: '',
				authorName: '',
				status: '',
				publicationEvent: '',
				publicationTypeId: '',
				attendees: ''
			}
		}, () => {
			this.fetchTableData();
		});
	}

	// Initial page load
	componentDidMount() {
		if (this.props.userData && this.props.userData.id && this.props.activeOrg) {
			this.fetchInitialData();
		}
		else {
			this.setState({
				error: {message: 'Encountered a problem with user data. (SP31)'}
			});
		}
	}

	render() {
		// Sanity checking
		if (this.state.error) {
			return <div className='error-text'>
				Error: {
					this.state.error.message
					? this.state.error.message
					: 'An unknown error has occurred (SP75)'
				}
			</div>;
		}
		else if (!this.state.isLoaded) { // Display nothing until we're ready for user input
			return <div>Loading <img src={loading_gif} alt='loading gif' style={{ verticalAlign: 'middle' }} /></div>;
		}

		const statusCodes = ['Planned', 'Submitted', 'In Review', 'In Press', 'Published'];

		// Individual Rows
		const outputContent = this.state.tableData.map((rowData) => {
			const thisRowCols = this.state.tableCols.map((colData) => {
				switch (colData.columnName) {
					case 'author':
						return <td style={{ textAlign: 'left' }} key={rowData.id + 'author-td'} >{
							rowData.authors.map((author) => {
								const lastName = author.lastName;
								const firstInit = (author.firstName !== null && author.firstName.length)
									? ' ' + author.firstName.charAt(0) + '.'
									: '';
								const middleInit = (author.middleName !== null && author.middleName.length)
									? author.middleName.charAt(0) + '.'
									: '';
								const citationName = lastName + (firstInit !== null ? firstInit + middleInit : '');

								return citationName;
							}).join(', ')
						}</td>;
					case 'status':
						return <td key={rowData.id + 'status-td'} >{
							statusCodes[rowData.status]
						}</td>;
					case 'publishedDate': // Gotta format that thing
						let itemDate = '';
						let pubDate = new Date(rowData.publishedDate.replace(' ', 'T'));
						switch (rowData.datestyle) { // It is just plain stupid that JS doesn't have an easier way to format dates
							case 'MDY':
								itemDate = (pubDate.getMonth() + 1) + '/' + pubDate.getDate() + '/' + pubDate.getFullYear();
								break;
							case 'MY':
								itemDate = (pubDate.getMonth() + 1) + '/' + pubDate.getFullYear();
								break;
							case 'YYYY':
								itemDate = pubDate.getFullYear();
								break;
							default:
								itemDate = (pubDate.getMonth() + 1) + '/' + pubDate.getDate() + '/' + pubDate.getFullYear();
						}
						return <td key={rowData.id + 'date-td'} >{itemDate}</td>;
					case 'title':
						if (rowData.artifactUrl) {
							if (rowData.abstractText) {
								return <td style={{ textAlign: 'left' }} key={rowData.id + 'title-td'} >
									<a
										href={rowData.artifactUrl}
										target='_blank'
										rel='noopener noreferrer'
										className='tooltip'
										style={{textDecoration: 'none', color: 'inherit'}}
									>
										{rowData[colData.columnName]}
										<span className='tooltiptext-bottom'>{rowData.abstractText}</span>
									</a>
								</td>;
							}
							else {
								return <td style={{ textAlign: 'left' }} key={rowData.id + 'title-td'} >
									<a
										href={rowData.artifactUrl}
										target='_blank'
										rel='noopener noreferrer'
										style={{textDecoration: 'none', color: 'inherit'}}
									>
										{rowData[colData.columnName]}
									</a>
								</td>;
							}
						}
						else if (rowData.abstractText) {
							return <td style={{ textAlign: 'left' }} key={rowData.id + 'title-td'} >
								<span
									className='tooltip'
								>
									{rowData[colData.columnName]}
									<span className='tooltiptext-bottom'>{rowData.abstractText}</span>
								</span>
							</td>;
						}
						else {
							return <td
								style={{ textAlign: 'left' }}
								key={rowData.id + 'title-td'}
							>
								{rowData[colData.columnName]}
							</td>;
						}
					case 'publicationEvent':
						return <td
							style={{ textAlign: 'left' }}
							key={rowData.id + '-' + colData.columnName + '-td'}
						>
							{rowData[colData.columnName]}
						</td>;
					case 'publicationTypeId':
						return <td key={rowData.id + '-' + colData.columnName + '-td'} >
							{this.state.pubTypesList.filter(pubType => pubType.id === rowData.publicationTypeId)[0].typeName}
						</td>;
					default:
						return <td key={rowData.id + '-' + colData.columnName + '-td'} >
							{rowData[colData.columnName]}
						</td>; // Everything else is fine as-is
				}
			});

			const thisRow = <tr key={'row-' + rowData.id} >{thisRowCols}</tr>;

			return thisRow;
		});

		// Previous/Next
		const paginationContent = (
		<tr>
			<td
				onClick={this.prevPage}
				className={'clickable pagination-navigation-' + ((this.state.page >= 1) ? 'active' : 'inactive')}
			>
				Previous
			</td>
			{
				this.state.tableCols.length > 2
					? <td colSpan={this.state.tableCols.length - 2} />
					: null
			}
			<td
				onClick={this.nextPage}
				className={'clickable pagination-navigation-' + ((this.state.page < (this.state.totalPages - 1)) ? 'active' : 'inactive')}
			>
				Next
			</td>
		</tr>
		);

		// Search header row
		let searchHeader = [];
		if (this.state.tableCols.filter(column => column.columnName === 'author').length) {
			searchHeader.push(
				<th className='site-preview-header' key='author-search-th' >
					<input
							type='text'
							name='authorName'
							maxLength={15}
							onChange={this.filterChange}
							value={this.state.filterArr['authorName']}
						/>
				</th>
			);
		}
		if (this.state.tableCols.filter(column => column.columnName === 'title').length) {
			searchHeader.push(
				<th className='site-preview-header' key='title-search-th' >
					<input
						type='text'
						name='title'
						maxLength={15}
						onChange={this.filterChange}
						value={this.state.filterArr['title']}
					/>
				</th>
			);
		}
		if (this.state.tableCols.filter(column => column.columnName === 'status').length) {
			searchHeader.push(
				<th className='site-preview-header' key='status-search-th' >
					<select
						name='status'
						onChange={this.filterChange}
						value={this.state.filterArr['status']}
					>
						<option value='' >Select All</option>
						{
							statusCodes.map((name, idx) => {
								return <option value={idx} key={'status-' + idx} >{name}</option>;
							})
						}
					</select>
				</th>
			);
		}
		if (this.state.tableCols.filter(column => column.columnName === 'publicationEvent').length) {
			searchHeader.push(
				<th className='site-preview-header' key='publicationEvent-search-th' >
					<input
						type='text'
						name='publicationEvent'
						maxLength={15}
						onChange={this.filterChange}
						value={this.state.filterArr['publicationEvent']}
					/>
				</th>
			);
		}
		if (this.state.tableCols.filter(column => column.columnName === 'publicationTypeId').length) {
			searchHeader.push(
				<th className='site-preview-header' key='type-search-th' >
					<select
						name='publicationTypeId'
						onChange={this.filterChange}
						value={this.state.filterArr['publicationTypeId']}
					>
						<option value='' >Select All</option>
						{
							this.state.pubTypesList.map((code) => {
								return <option value={code.id} key={'type-' + code.id} >{code.typeName}</option>;
							})
						}
					</select>
				</th>
			);
		}
		if (this.state.tableCols.filter(column => column.columnName === 'publishedDate').length) {
			searchHeader.push(
				<th className='site-preview-header' key='date-search-th' >
					<input
						type='number'
						name='publishedDate'
						min={0}
						max={3000}
						onChange={this.filterChange}
						value={this.state.filterArr['publishedDate']}
						style={{ width: 45 }}
					/>
				</th>
			);
		}
		if (this.state.tableCols.filter(column => column.columnName === 'attendees').length) {
			searchHeader.push(
				<th className='site-preview-header' key='attendees-search-th' >
					<input
						type='number'
						name='attendees'
						min={0}
						max={9999999}
						onChange={this.filterChange}
						value={this.state.filterArr['attendees']}
					/>
				</th>
			);
		}

		// Site Preview Table
		const outputTable = this.state.tableCols.length
		? (
			<table className='site-preview-table' >
				<thead className='site-preview-head-row' >
					<tr>
						{ this.state.tableCols.map((colData) => {
								switch (colData.columnName) {
									case 'author':
										return (
											<th 
												className='site-preview-head clickable' 
												name='firstAuthor'
												onClick={this.sortChange}
												key='author-th'
											>
												{colData.columnName }
												{this.state.sortCol === 'firstAuthor' 
													? this.state.sortDir === 'asc' 
														? <button 
															className='icon-sort-up-arrow ui-icon' 
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}} 
														/>
														: <button
															className='icon-sort-down-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
													: <button
														className='icon-sort-up-and-down-arrow ui-icon'
														style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
													/>
												}
											</th>
										);
									case 'publishedDate':
										return (
											<th
												className='site-preview-head clickable'
												onClick={this.sortChange}
												name={colData.columnName}
												key='date-th'
											>
												Date
												{this.state.sortCol === colData.columnName
													? this.state.sortDir === 'asc'
														? <button
															className='icon-sort-up-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
														: <button
															className='icon-sort-down-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
													: <button
														className='icon-sort-up-and-down-arrow ui-icon'
														style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
													/>
												}
											</th>
										);
									case 'publicationTypeId':
										return (
											<th
												className='site-preview-head clickable'
												onClick={this.sortChange}
												name={colData.columnName}
												key='type-th'
											>
												Type
												{this.state.sortCol === colData.columnName
													? this.state.sortDir === 'asc'
														? <button
															className='icon-sort-up-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
														: <button
															className='icon-sort-down-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
													: <button
														className='icon-sort-up-and-down-arrow ui-icon'
														style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
													/>
												}
											</th>
										);
									case 'publicationEvent':
										return (
											<th
												className='site-preview-head clickable'
												onClick={this.sortChange}
												name={colData.columnName}
												key={colData.columnName + '-th'}
											>
												Publication/Event
												{this.state.sortCol === colData.columnName
													? this.state.sortDir === 'asc'
														? <button
															className='icon-sort-up-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
														: <button
															className='icon-sort-down-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
													: <button
														className='icon-sort-up-and-down-arrow ui-icon'
														style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
													/>
												}
											</th>
										);
									default:
										return (
											<th
												className='site-preview-head clickable'
												onClick={this.sortChange}
												name={colData.columnName}
												key={colData.columnName + '-th'}
											>
												{ colData.columnName }
												{this.state.sortCol === colData.columnName
													? this.state.sortDir === 'asc'
														? <button
															className='icon-sort-up-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
														: <button
															className='icon-sort-down-arrow ui-icon'
															style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
														/>
													: <button
														className='icon-sort-up-and-down-arrow ui-icon'
														style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
													/>
												}
											</th>
										);
								}
							})
						}
					</tr>
					<tr>{searchHeader}</tr>
				</thead>
				<tbody>
					{outputContent}
				</tbody>
				<tfoot>
					{paginationContent}
				</tfoot>
			</table>
		)
		: null;

		// Page at large
		return (
			<div>
				<h2>Webpage Display: View by Webpage</h2>
				<div>
					<label
						htmlFor='siteSwap'
						style={{display: 'block'}}
						className='site-preview-label'
					>
						Webpage Display:
					</label>
					<select
						name='siteSwap'
						value={this.state.selectedSite || ''}
						onChange={this.handleSiteSwapChange}
					>
						<option value='' >Please select a site</option>
						{
							this.state.sitesList.map((site) => {
								return <option value={site.id} key={'status-' + site.id} >{
									site.url
										? site.url  // Default to URL
										: site.name
											? site.name // Fall back to name
											: 'Page #' + site.id // Last resort is the id
								}</option>;
							})
						}
					</select>
				</div>
				{outputTable}
			</div>
		);
	}
}

export default SitePreview;
